import { jsxs as a, jsx as r } from "react/jsx-runtime";
import { useRef as p, useState as e } from "react";
import { HyperLinkModalTitle as y, LinkIcon as S, FormBody as B, HyperLinkModalLabel as c, HyperLinkModalButton as H } from "./style.js";
import { TextInput as k } from "../../../../components/TextInput/index.js";
import { parseToValidUrl as f } from "../../services/parseToValidUrl/index.js";
import { Link as j } from "@pelando/fontawesome/icons";
import { useTranslation as C } from "../../../../hooks/useTranslation/index.js";
import { TextInputMessageStatus as D } from "../../../../components/TextInput/types.js";
import { useModal as V } from "../../../../components/Modal/context.js";
function G({ onAddLink: h, selectedText: o }) {
  const { t: i } = C("common"), s = p(null), m = p(null), [b, I] = e(!0), [d, L] = e(!1), [M, u] = e(void 0), { closeModal: g } = V(), v = () => {
    var t, l;
    const n = f(((t = m.current) == null ? void 0 : t.value) || "");
    n && (h({
      link: n,
      text: (o == null ? void 0 : o.trim()) || ((l = s.current) == null ? void 0 : l.value.trim()) || n
    }), g());
  }, R = (n) => {
    const t = n == null ? void 0 : n.target.value, l = !f(t);
    if (I(l), L(l), !l) {
      u(void 0);
      return;
    }
    u({
      text: i("link-modal-error-message"),
      type: D.ERROR
    });
  };
  return /* @__PURE__ */ a(
    "form",
    {
      onSubmit: (n) => {
        n.preventDefault(), v();
      },
      children: [
        /* @__PURE__ */ a(y, { id: "modal-title", children: [
          /* @__PURE__ */ r(S, { icon: j, "aria-label": i("link-modal-icon") }),
          i("link-modal-title")
        ] }),
        /* @__PURE__ */ a(B, { "data-invalid": d, children: [
          /* @__PURE__ */ a(c, { children: [
            /* @__PURE__ */ r("span", { children: i("link-modal-text") }),
            /* @__PURE__ */ r(
              k,
              {
                innerRef: s,
                defaultValue: o,
                disabled: !!(o != null && o.trim()),
                placeholder: i("link-modal-placeholder-text")
              }
            )
          ] }),
          /* @__PURE__ */ a(c, { children: [
            /* @__PURE__ */ r("span", { children: i("link-modal-address") }),
            /* @__PURE__ */ r(
              k,
              {
                innerRef: m,
                placeholder: i("link-modal-placeholder-address"),
                invalid: d,
                onChange: R,
                message: M
              }
            )
          ] })
        ] }),
        /* @__PURE__ */ r(H, { disabled: b, type: "submit", children: i("link-modal-button-submit") })
      ]
    }
  );
}
export {
  G as LinkModal
};
